import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';

export const StyledMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export const StyledContainer = styled.div<{
  justifyContent?: 'start' | 'end' | 'center';
  padding?: string;
}>`
  display: flex;
  padding: ${({ padding }) => padding ?? '2rem'};
  flex-direction: column;
  gap: 1rem;
  flex: 1;
  justify-content: ${({ justifyContent }) => justifyContent ?? 'start'};
`;

export const StyledInputGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledInputGroupRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const TermsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0;
`;

export const TermsText = styled.a`
  color: ${theme.colors.tenant.main};
  font-family: 'Nunito';
  padding: 0;
  font-weight: bold;
  margin: 0;
`;

export const InfoIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0.5rem 1.5rem;
  border-radius: 0.5rem;
  gap: 1rem;
  background-color: #ff74001a;
  color: #ff7400;
`;

export const IconContainer = styled.div`
  display: flex;
  min-width: 1.3rem;
`;

export const StyledButton = styled.button`
  background: ${theme.colors.tenant.main};
  padding: 0.5rem;
  border: 0;
  border-radius: 0.5rem;
  align-self: end;
  color: #fff;
  width: 12rem;
  &:hover {
    cursor: pointer;
    background: ${theme.colors.tenant.mainAlternate};
  }
  &:disabled {
    cursor: not-allowed;
    background: ${theme.colors.cross.silverFox};
  }
`;
